export default __webpack_public_path__ + "media/images/features/local_delivery/episode7/LP_05-ae53b42250323198297fc3ae62e5f93b.png";